<template>
  <div class="header">
    <div class="navbar"
         :style="{backgroundColor:'white'}">
      <div class="nav-img" @click="$router.push('/')">
      </div>




<!--      <div class="test-zone">-->
<!--        <nuxt-link to="/customPage/shanxi">index</nuxt-link>-->
<!--      </div>-->



      <div class="nav-btn">
        <div id="home">
          <div class="home-btn "
               @click="$router.push('/')"
               @mouseenter="btnEnter($event,'inHomeBtn')"
               @mouseleave="btnLeave($event,'inHomeBtn')"
               :class="{'active-btn':page==='home'||inHomeBtn,'disable-btn':page!=='home'&&!inHomeBtn}">
            首页
          </div>
        </div>
        <div id="produce"
             style="position: relative">
          <div class="home-btn"
               @click="clickNav($event,'produce')"
               @mouseenter="btnEnter($event,'inProduceBtn')"
               @mouseleave="btnLeave($event,'inProduceBtn')"
               :class="{'active-btn':(page==='produceBiological'||page==='produceChemistry'||page==='producePhysical')||inProduceBtn,'disable-btn':page!=='produceBiological'&&page!=='produceChemistry'&&page!=='producePhysical'&&!inProduceBtn}">
            产品列表
          </div>
          <div v-if="produceClick"
               class="solution-card-group"
               ref="produce-card"

               style="height: 6vw">
            <div class="solution-card"
                 @click="clickNav($event,'experiment')">
              <div class="solution-card-pic pic2">
              </div>
              <div class="solution-card-text"
                   @click="$emit('produceLink','physical')">
                仿真实验教学系统
              </div>
              <i class="el-icon-right"
                 style="height:2vw;line-height:2vw;text-align:center;margin:0 0.3vw 0;color:rgb(131, 71, 255)"></i>
              <div v-if="experiment"
                   class="produce-menu-card-1">
                <div class="produce-card card-1">
                  <div class="produce-card-text"
                       @click="toNewWindow('physical')">
                    初中物理仿真实验
                  </div>
                </div>
                <div class="produce-card card-1"
                     @click="toNewWindow('chemistry')">
                  <div class="produce-card-text">
                    初中化学仿真实验
                  </div>
                </div>
                <div class="produce-card card-1"
                     @click="toNewWindow('biological')">
                  <div class="produce-card-text">
                    初中生物仿真实验
                  </div>
                </div>

              </div>
            </div>
            <div class="solution-card"
                 @click="clickNav($event,'vr')">
              <div class="solution-card-pic pic4">
              </div>
              <div class="solution-card-text">
                VR课程系统
              </div>
              <i class="el-icon-right"
                 style="height:2vw;line-height:2vw;text-align:center;margin:0 0.3vw 0;color:rgb(131, 71, 255)"></i>
              <div v-if="vrClass"
                   class="produce-menu-card-1"
                   style="height: 4vw">
                <div class="produce-card card-3" @click="$router.push('/produce/VR?way=desktop')">
                  <div class="produce-card-text">
                    桌面式VR
                  </div>
                </div>
                <div class="produce-card card-3" @click="$router.push('/produce/VR?way=vr')">
                  <div class="produce-card-text">
                    沉浸式VR
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div style="position: relative">
           <div class="home-btn"

                @click="clickSolution"
                @mouseenter="btnEnter($event,'inSolutionBtn')"
                @mouseleave="btnLeave($event,'inSolutionBtn')"
                :class="{'active-btn':page==='solution'||inSolutionBtn,'disable-btn':page!=='solution'&&!inSolutionBtn}">
             解决方案

           </div>
           <div v-if="solutionFlag"
                class="solution-card-group"
                ref="solution-card">
             <div class="solution-card"
                  @click="solutionPage('xr')">
               <div class="solution-card-pic pic1">
               </div>
               <div class="solution-card-text">
                 VR创新实验室解决方案
               </div>
             </div>
             <div class="solution-card"
                  @click="solutionPage('create')">
               <div class="solution-card-pic pic2">
               </div>
               <div class="solution-card-text">
                 创客空间解决方案
               </div>
             </div>
             <div class="solution-card"
                  @click="solutionPage('math')">
               <div class="solution-card-pic pic3">
               </div>
               <div class="solution-card-text">
                 数字化探究实验解决方案
               </div>
             </div>
             <div class="solution-card"
                  @click="solutionPage('physical')">
               <div class="solution-card-pic pic4">
               </div>
               <div class="solution-card-text">
                 理化生实操考试综合解决方案
               </div>
             </div>
             <div class="solution-card"
                  @click="solutionPage('classroom')">
               <div class="solution-card-pic pic5">
               </div>
               <div class="solution-card-text">
                 常态化教学解决方案
               </div>
             </div>
           </div>
         </div>
         <div>
            <a class="home-btn" style="text-decoration:none;color:inherit;"
               href="https://lab.ekwclass.com">
              <i class="el-icon-monitor" style="margin-right:2px;"></i>实验平台
           </a>
         </div>
         <div>
            <div class="home-btn"
                 @click="$router.push('/app-download')">
              <i class="el-icon-download" style="margin-right:2px;"></i>App下载
           </div>
         </div>


      </div>
      <div class="nav-login">
        <div v-if="loginStatus"
             style="position: relative;display: flex;width: 5vw;height: 2vw;">
          <div class="message-ding"
               @click="$router.push('/userMessage')">
            <i class="el-icon-message-solid"
               style="font-size: 0.7vw"></i>
            <div class="red-point"
                 v-if="messageCount>0"><span style="color: white;">{{messageCount>9?'9+':messageCount}}</span></div>
          </div>
          <div class="user-pic"
               id="user-pic-btn"
               @click="showCard">
          </div>
          <div class="user-card"
               id="person-card"
               @click="clickZone"
               v-if="cardFlag"
               ref="user-card-list">
            <div style="  display: flex;flex-direction: column;">
              <div class="user-card-pic"></div>
              <div style='position: absolute;z-index:999'>
                <div class="user-msg">
                  <span style="display: inline-block">{{username=='250'?'249':username}}</span>
                  <span style="display: inline-block">{{'ID：'+(account.length>7?account.slice(0,7)+'...':account)}}</span>
                </div>
              </div>
              <div class="user-btn-list">
                <div class="user-card-btn"
                     @click="changeRight('toHome')">
                  <img class="user-btn-pic"
                       src="http://data.xiyilab.com/web/main/static/home/p__基本资料大icon-拷贝.png">
                  <div class="user-btn-text">个人中心</div>
                </div>
                <div class="user-card-btn"
                     @click="changeRight('exit')">
                  <img class="user-btn-pic"
                       src="http://data.xiyilab.com/web/main/static/home/安全退出icon.png">
                  <div class="user-btn-text"
                       @click="logout=true">安全退出</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div v-else
             class="btn-list" style="justify-content: center">
        </div>
      </div>
    </div>
    <div class="card-pic"

         v-if="$route.path==='/'||$route.path==='/solution'||$route.path==='/produceList'||$route.path==='/aboutUS'||$route.path==='/produce/physical'||$route.path==='/produce/chemistry'||$route.path==='/produce/biology'||$route.path==='/produce/VR'">
      <el-carousel  trigger="click"
                   height="42vw"
                   autoplay
                   :indicator-position="imgList.length>1?'':'none'"
                   :arrow="imgList.length>1?'always':'none'"
                   style="position: absolute;top: 0;left: 0;width: 100%;overflow: hidden">
        <el-carousel-item v-for="(item,index) in imgList"
                          :key="index">
          <div
            @click="openOnlineApp('生物')"
            class="banner-icon"
            style="
              width: 12vw;
              height: 4vw;
              z-index: 999;
              top:30vw;
              background-image: url('http://data.xiyilab.com/web/main/static/理化生/生物按钮.png');
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              left: 18.5vw;
              cursor: pointer;
              overflow: hidden;
              position: absolute;"
            v-if="page==='produceBiological'" >
            <div  style="position:absolute;top:1.5vw;left:2vw; font-family: test;font-size: 1.2vw;letter-spacing: 1px;color: white;">
              开始实验
            </div>
            <div class="right-icon" style="background: url('http://data.xiyilab.com/web/main/static/理化生/箭头.png') no-repeat center;width: 1.5vw;height: 0.8vw;position: absolute;right:2.5vw;bottom:1.3vw;background-size: cover;"></div>
          </div>
          <div
            @click="openOnlineApp('化学')"
            class="banner-icon"
            style="
              width: 12vw;
              height: 4vw;
              z-index: 999;
              top:30vw;
              background-image: url('http://data.xiyilab.com/web/main/static/理化生/化学按钮.png');
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              left: 18.5vw;
              cursor: pointer;
              overflow: hidden;
              position: absolute;"
            v-if="page==='produceChemistry'" >
            <div  style="position:absolute;top:1.5vw;left:2vw; font-family: test;font-size: 1.2vw;letter-spacing: 1px;color: white;">
              开始实验
            </div>
            <div class="right-icon" style="background: url('http://data.xiyilab.com/web/main/static/理化生/箭头.png') no-repeat center;width: 1.5vw;height: 0.8vw;position: absolute;right:2.5vw;bottom:1.3vw;background-size: cover;"></div>
          </div>
          <div
            @click="openOnlineApp('物理')"
            class="banner-icon"
            style="
              width: 12vw;
              height: 4vw;
              z-index: 999;
              top:30vw;
              background-image: url('http://data.xiyilab.com/web/main/static/理化生/物理按钮.png');
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              left: 19vw;
              cursor: pointer;
              overflow: hidden;
              position: absolute;"
            v-if="page==='producePhysical'" >
            <div  style="position:absolute;top:1.5vw;left:2vw; font-family: test;font-size: 1.2vw;letter-spacing: 1px;color: white;">
              开始实验
            </div>
            <div class="right-icon" style="background: url('http://data.xiyilab.com/web/main/static/理化生/箭头.png') no-repeat center;width: 1.5vw;height: 0.8vw;position: absolute;right:2.5vw;bottom:1.3vw;background-size: cover;"></div>
          </div>
          <div
            v-if="page==='producePhysical'"
            style="
              top:20vw;
              left:18.5vw;
              width: 31.875vw;
              height: 1.2vw;
              font-family: test;
              font-size: 1.2vw;
              font-weight:400;
              font-stretch: normal;
              line-height: 6vw;
              letter-spacing: 1px;
              color: #ffffff;
              z-index: 999;
              position: absolute">
            物理定律不能单靠思维来获得，还应致力于观察与实验
          </div>
          <div @click="toOnlineApp"
               style="width: 6vw;
               font-family: test;
               text-align: center;
            height: 2vw;
            font-size: 0.85vw;
            line-height: 2vw;
            color: #5eb2f7;
            border-radius: 2vw;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: nowrap;
            background-color: white;
            position:fixed;
            cursor: pointer;
            top:30vw;left: 20vw;
            z-index: 999"
               v-if="index===0&&page==='home'">
            <div style="letter-spacing: 1px;font-weight: 600">
              开始实验
            </div>
          </div>
          <div @click="toOnlineApp"
               style="width: 6vw;
               text-align: center;
               font-family: test;
            height: 2vw;
            font-size: 0.85vw;
            line-height: 2vw;
            color: #5eb2f7;
            border-radius: 2vw;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: nowrap;
            background-color: white;
            position:fixed;
            cursor: pointer;
            top:30vw;left: 34vw;
            z-index: 999"
               v-if="index===1&&page==='home'">
            <div style="letter-spacing: 1px;font-weight: 600">
              开始实验
            </div>
          </div>
          <div @click="toOnlineApp"
               style="width: 6vw;
               font-family: test;
               text-align: center;
            height: 2vw;
            font-size: 0.85vw;
            line-height: 2vw;
            color: #645db4;
            border-radius: 2vw;
            display: flex;
            cursor: pointer;
            justify-content: center;
            align-items: center;
            flex-wrap: nowrap;
            background-color: white;
            position:fixed;
            top:30vw;left: 46.8vw;
            z-index: 999"
               v-if="index===2&&page==='home'">
            <div style="letter-spacing: 1px;font-weight: 600">
              开始实验
            </div>
          </div>
          <img :src="item.src"
               style="height:100%;width:100%;"
               alt="图片丢失了" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <el-dialog :visible="logout"
               width="30%"
               title="警告">
      <span>确认退出吗？当前未保存的操作将全部失效！！！</span>
      <template slot="footer">
        <el-button @click="logout=false">取消</el-button>
        <el-button @click="logOut">确认</el-button>
      </template>
    </el-dialog>
  </div>

</template>


<script>
import { getToken } from '@/utils/auth'
import { getMessageCount } from '@/api/message'
import { getStudentSchoolInfo } from '@/api/school'
import $ from 'jquery'


export default {
  name: 'NavHeader',

  props: {
    router: {
      type: Array,
    },
    status: {
      type: Object,
    }
  },
  computed: {
    produce_second_menu: function () {
      return this.experiment || this.vrClass
    }
  },
  mounted () {
    let that=this
    document.onclick = function () {
      that.$nextTick(()=>{
        that.cardFlag=false
        that.vrClass=false
        that.experiment=false
        that.solutionFlag=false
        that.produceClick=false
      })
    }
    this.user_type = localStorage.getItem('user_identity') || '游客'
    this.routerList = JSON.parse(localStorage.getItem('router'))
    getMessageCount().then(res => {
      if (res.status === 'ok') {
        this.messageCount = res.data['unread_counter']
      }
      else {
        if (getToken()) {
          this.$message.warning('暂时无法获取消息通知')
        }
      }

    })
    this.$nextTick(() => {
      let token = localStorage.getItem('token') || getToken()
      this.loginStatus = token ? true : false
      let userdata = {
        email: localStorage.getItem('account'),
        account: localStorage.getItem('account'),
        uid: localStorage.getItem('uid'),
        username: localStorage.getItem('username'),
        hasPwd: localStorage.getItem('hasPwd'),
        user_type: localStorage.getItem('user_type'),
        token: localStorage.getItem('token'),
        province: localStorage.getItem('province'),
        city: localStorage.getItem('city'),
        area: localStorage.getItem('area'),
        school: localStorage.getItem('school'),
        sex: localStorage.getItem('sex')
      }
      if (token) {
        this.$store.dispatch('User/reLogin', userdata)
      }
      this.username = userdata.username || userdata.uid
      this.account = userdata.account
    })
  },
  data () {
    return {
      user_type: '',
      messageCount: '',
      page: '',
      btn1:'',
      menu1:'',
      username: '',
      account: '',
      solutionFlag:this.status.page==='solution'?true:false,
      logout: false,
      experiment: false,
      vrClass: false,
      produceHover: true,
      produceClick: this.status.page === 'produce' ? true : false,
      loginStatus: false,
      imgList: [],
      routerList: [],
      timer:null,
      cardFlag: false,
      homeImgList: [
        {
          name: "1",
          src: "http://data.xiyilab.com/web/main/static/首页/banner1.png",
          title: "这是banner1.png"
        },
        {
          name: "2",
          src: "http://data.xiyilab.com/web/main/static/首页/banner2.png",
          title: "这是banner2.png"
        },
        {
          name: "3",
          src: "http://data.xiyilab.com/web/main/static/首页/banner3.png",
          title: "这是banner3.png"
        },
        {
          name: "4",
          src: "http://data.xiyilab.com/web/main/static/首页/图标banner.png",
          title: "这是banner4.png"
        }
      ],
      producePhysicalImgList:[
        {
          name: "1",
          src: "http://data.xiyilab.com/web/main/static/理化生/物理banner.png",
          title: "这是banner1.png"
        },
      ],
      produceChemistryImgList:[
        {
          name: "2",
          src: "http://data.xiyilab.com/web/main/static/理化生/化学banner.png",
          title: "这是banner2.png"
        },
      ],
      produceBiologicalImgList:[
        {
          name: "3",
          src: "http://data.xiyilab.com/web/main/static/理化生/生物banner.png",
          title: "这是banner3.png"
        }
      ],
      produceVRImgList:[
        {
          name: "2",
          src: "http://data.xiyilab.com/web/main/static/VR/banner.png",
          title: "这是banner2.png"
        },
      ],
      aboutImgList: [
        {
          name: "1",
          src: "http://data.xiyilab.com/web/main/static/关于我们/banner.png",
          title: "这是banner1.png"
        }
      ],
      xrImgList: [{
        name: "1",
        src: "http://data.xiyilab.com/web/main/static/解决方案/创新实验室banner.png",
        title: "xr"
      }],
      createImgList: [{
        name: "2",
        src: "http://data.xiyilab.com/web/main/static/解决方案/创客空间banner.png",
        title: "create"
      }],
      mathImgList: [{
        name: "3",
        src: "http://data.xiyilab.com/web/main/static/解决方案/数字化实验室.png",
        title: "math"
      }],
      physicalImgList: [{
        name: "4",
        src: "http://data.xiyilab.com/web/main/static/解决方案/理化生实验室banner.png",
        title: "physical"
      }],
      classroomImgList: [
        {
          name: "5",
          src: "http://data.xiyilab.com/web/main/static/解决方案/常态化教室banner.png",
          title: "classroom"
        },
        {
          name: "6",
          src: "http://data.xiyilab.com/web/main/static/解决方案/多媒体机房banner.png",
          title: "media"
        },
      ],
      inHomeBtn: false,
      inProduceBtn: false,
      inSolutionBtn: false,
      inAboutUSBtn: false,
      inAppBtn: false,
      inMessageBtn: false
    }

  },
  created () {

    this.page = this.status.page
    if (this.page === 'solution') {
      this.imgList = this['xrImgList']
    }
    else {
      this.imgList = this[this.status.page + 'ImgList'] || []
    }
    console.log(this.page)
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
    this.btn1=document.getElementById('user-pic-btn')
    this.menu1=document.getElementById('person-card')
  },

  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    downloadFile(){
      this.$router.push({
        path:'/download'
      })
    },
    toLogin(page){
      if(page==='login'){
        let url=this.$router.resolve({
          path:'/login?way=登录'
        })
        window.open(url.href,'_blank')
      }
      else{
        let url=this.$router.resolve({
          path:'/login?way=注册'
        })
        window.open(url.href,'_blank')
      }
    },
    clickNav(e,card){
      switch (card){
        case 'vr':{
          e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
          this.vrClass=!this.vrClass
          this.experiment=false
          break
        }
        case 'experiment':{
          e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
          this.vrClass=false
          this.experiment=!this.experiment
          break
        }
        case 'produce':{
          e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
          if(this.cardFlag){
            this.cardFlag=false
          }
          if(this.solutionFlag){
            this.solutionFlag=false
          }
          this.produceClick=!this.produceClick
          break
        }
      }
    },
    clickZone(e){
      e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
    },
    setTimer() {
      if(this.timer == null) {
        this.timer = setInterval( () => {
          if(!localStorage.getItem('uid')&&this.loginStatus){
            this.$router.push('/')
          }
        }, 1000)
      }
    },
    logOut () {
      this.$store.dispatch('User/logout')
      this.logout = false
      let account=localStorage.getItem('rem_account')
      let password=localStorage.getItem('rem_password')
      localStorage.clear()
      localStorage.setItem('rem_account', account);
      localStorage.setItem('rem_password', password);
      setTimeout(() => {

        if (this.$route.path !== '/') {
          this.$router.push('/')
        }
        else {
          this.$router.go(0);
        }
      }, 500)
    },
    produceMenuIn () {
      console.log(this.produceHover)
      this.$nextTick(() => {
        this.produceHover = true
      })

    },
    produceMenuOut () {
      console.log(this.produceHover)
      this.$nextTick(() => {
        this.produceHover = false
      })

      if (!this.produce_second_menu) {
        this.produceClick = false
      }
    },
    btnEnter (event, btn) {
      this[btn] = !this[btn]
    },
    btnLeave (event, btn) {
      this[btn] = !this[btn]
    },
    clickProduce () {
      this.produceClick = !this.produceClick
    },
    solutionPage (id) {
      this.imgList = this[id + 'ImgList']
      this.$emit('switchSolutionPage', id)

    },
    clickSolution (e) {
      console.log(this.status.solution)
      e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
      if (this.status.page !== 'solution') {
        this.$router.push('/solution?title=xr')
      }
      if (this.status.page === 'solution') {
        this.solutionFlag=!this.solutionFlag
        if(this.cardFlag){
          this.cardFlag=false
        }
        if(this.produceClick){
          this.produceClick=false
        }
        // this.$refs['solution-card'].hidden = !this.$refs['solution-card'].hidden
      }
    },
    showCard (e) {
      e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
       this.cardFlag = !this.cardFlag
      if(this.produceClick){
        this.produceClick=false
      }
      if(this.vrClass){
        this.vrClass=false
      }
      if(this.solutionFlag){
        this.solutionFlag=false
      }
      if(this.experiment){
        this.experiment=false
      }
    },
    changeRight (title) {
      console.log(title)
      if(title==='toHome'){
        this.$router.push('/home')
      }
      // if (title !== 'exit') {
      //   if (this.page === 'homePage') {
      //     this.$emit('changeRight', title)
      //   }
      //   else {
      //     console.log(title)
      //     this.$router.push("/home?rightPage=" + title)
      //   }
      // }
    },
    toOnlineApp () {
      let url = new URL(window.location.href)
      console.log(this.user_type)
      if(this.user_type==='普通用户'){
         window.open(url.origin + '/lab/onlineCustomApp')
      }
      else if (this.user_type === '老师' || this.user_type ==='学生' || this.user_type ==='学校管理员'){
        window.open(url.origin + '/lab/online-app')
      }
      else{
        window.open(url.origin + '/lab/login?way=登录')
      }
    },
    openOnlineApp(subject){
      let url = new URL(window.location.href)
      console.log(this.user_type)
      if (this.user_type === '老师' || this.user_type ==='学生' || this.user_type ==='学校管理员') {
        window.open(url.origin + '/lab/online-app?subject='+subject)
      }
      else{
        if(this.user_type==='普通用户'){
         window.open(url.origin + '/lab/onlineCustomApp')
        }
        else{
          window.open(url.origin + '/lab/login?way=登录')
        }
      }
      // else if(this.user_type ==='普通用户'){
      //   this.$message.error('您无权查看')
      // }
      // else{
      //   this.$message.error('您未登录，请先登录')
      //   setTimeout(()=>{
      //     this.$router.push('/login?way=登录')
      //   },1000)
      //
      // }
    },
    toNewWindow (subject) {
      let url = new URL(window.location.href)
      let flag=0;
      if (subject === 'teacher' && this.user_type === '老师') {
         window.open(url.origin + '/lab/teacherExam')
      }
      else if (subject === 'teacher'&&flag===0) {
        this.$message.error('您是' + this.user_type + '，无权访问')
        flag=1
      }


      if (subject === 'student' && this.user_type === '学生') {
        getStudentSchoolInfo().then(res => {
          if (res.status === 'ok') {
             window.open(url.origin + '/lab/studentExam?classroom=' + JSON.stringify(res.data.class))
          }
          else if(flag===0){
            flag=1
            this.$message.error('还未加入班级，请先申请加入自己的班级')
          }
        })

      }
      else if (subject === 'student'&&flag===0) {
        flag=1
        this.$message.error('您是' + this.user_type + '，无权访问')
      }


      if(subject==='banner'){
        if (this.user_type === '老师') {
          window.open(url.origin + '/lab/teacherExam')
        }
        else if ( this.user_type === '学生') {
          getStudentSchoolInfo().then(res => {
            if (res.status === 'ok') {
              window.open(url.origin + '/lab/studentExam?classroom=' + JSON.stringify(res.data.class))
            }
            else if(flag===0){
              flag=1
              this.$message.error('还未加入班级，请先申请加入自己的班级')
            }
          })

        }
        else  {
          this.$message.error('您未登录，请先登录')
          setTimeout(()=>{
            this.$router.push('/login?way=登录')
          },1000)
          flag=1
        }
      }

      if (subject === 'chemistry') {
        window.location.href=url.origin + '/lab/produce/chemistry'
      }
      if (subject === 'physical') {
        window.location.href=url.origin + '/lab/produce/physical'
      }
      if (subject === 'biological') {
        window.location.href=url.origin + '/lab/produce/biology'
      }
    }
  }
}
</script>


<style scoped>
*{
  font-family: test;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 1rem;
  opacity: 0.75;
  line-height: 2rem;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.header {
  width: 100vw;
  position: relative;
}
.card-pic {
  width: 100vw;
  height: 42vw;

  position: absolute;
  top: 0;
  z-index: 1;
}

.navbar {
  position: absolute;
  width: 100vw;
  height: 4vw;
  top: 0;
  z-index: 999;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.nav-img {
  cursor: pointer;
  width: 6vw;
  height: 3vw;
  margin-top: 0.5vw;
  margin-left: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.nav-btn {
  height: 2vw;
  margin-top: 1vw;
  margin-left: auto;
  margin-right: 3vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 3vw;
}
.nav-login {
  height: 2vw;
  margin-top: 1vw;
  margin-right: 3vw;
}
.home-btn {
  width: 5.5vw;
  height: 2vw;
  font-size: 0.8vw;
  line-height: 2vw;
  border-radius: 2vw;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  font-family: SourceHanSansCN-Bold;
  font-stretch: normal;
  letter-spacing: 0vw;
  color: #3e3a39;
  white-space: nowrap;
}
.home-btn-test{
  width: 5.5vw;
  height: 2vw;
  font-size: 0.8vw;
  line-height: 2vw;
  border-radius: 2vw;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  font-family: SourceHanSansCN-Bold;
  font-stretch: normal;
  letter-spacing: 0vw;
  color: #3e3a39;
  white-space: nowrap;
}
.home-btn-test:hover{
  background-color: #5eb2f7;
  color: white;
}
.active-btn {
  background-color: #5eb2f7;
  color: white;
}
.disable-btn {
  background-color: transparent;
  color: #3e3a39;
}
.btn-list {
  display: flex;
  flex-wrap: nowrap;
}
.solution-card-group {
  height: 10vw;
  background-color: white;
  position: absolute;
  top: 3vw;
  border-radius: 10px;
  line-height: 2vw;
  white-space: nowrap;
}
.solution-card {
  height: 2vw;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-end;
  cursor: pointer;
  align-content: center;
}
.solution-card:hover {
  background-color: rgba(131, 71, 255, 0.24);
}
.solution-card-pic {
  margin-left: 1vw;
  margin-right: 0.3vw;
  margin-top: 0.5vw;
  min-width: 16px;
  min-height: 16px;
  width: 1vw;
  height: 1vw;

  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.pic1 {
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/icon_5G+XR创新实验室.png");
}
.pic2 {
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/icon_创客空间.png");
}
.pic3 {
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/icon_数字化教室.png");
}
.pic4 {
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/icon_理化生学科实验室.png");
}
.pic5 {
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/icon_常态化教室.png");
}

.solution-card-text {
  margin-left: 0.3vw;
  height: 2vw;
  margin-right: 1vw;
  line-height: 2vw;
  text-align: left;
  font-size: 0.8vw;
  letter-spacing: 2px;
  color: #3e3a39;
  flex: 1;
}

.user-pic {

  width: 2vw;
  height: 2vw;
  margin: auto;
  border-radius: 50%;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.user-card {
  position: absolute;
  top: 3vw;
  right: -2vw;
  min-width: 100px;
  max-width: 200px;
  width: 8vw;

  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.user-card-pic {
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  max-height: 120px;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p__卡片背景.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-msg {
  display: flex;
  flex-direction: column;
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.7vw;
}
.user-card-btn {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  height: 2vw;
  min-height: 25px;
  cursor: pointer;
  width: 100%;
}
.user-btn-pic {
  object-fit: contain;
}
.user-btn-text {
  line-height: 2vw;
  height: 2vw;
  font-size: 0.7vw;
  text-align: center;
  margin-left: 1.5vw;
  white-space: nowrap;
}
.user-card-btn:hover {
  background-color: #f7e35e;
}
.produce-menu-card-1 {
  position: absolute;
  width: 8vw;
  min-width: 100px;
  height: 6vw;
  right: calc(0px - 8vw + 1px);
  background-color:white;
  display: flex;
  flex-direction: column;
  border-radius: 0 5px 5px 5px;
}
@media screen and (max-width: 1300px) {
  .produce-menu-card-1 {
    position: absolute;
    width: 8vw;
    min-width: 110px;
    height: 6vw;
    right: -110px;
    background-color: white;
    display: flex;
    flex-direction: column;
    border-radius: 0 5px 5px 5px;
  }
}
.produce-card {
  height: 2vw;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  cursor: pointer;
}
.card-1:hover {
  background-color: rgba(229, 247, 255, 0.6);
}
.card-2:hover {
  background-color: rgba(236, 252, 243, 0.8);
}
.card-3:hover {
  background-color: rgba(255, 250, 186, 0.8);
}
.produce-card-text {
  margin:0 auto 0;
  height: 2vw;
  line-height: 2vw;
  font-size: 0.7vw;
  letter-spacing: 2px;
  color: #3e3a39;
}
.fire {
  display: inline-block;
  margin: auto;
  min-width: 11px;
  min-height: 14px;
  width: 0.6vw;
  height: 0.6vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/火苗.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.nav-header-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/首页/按钮.png");
  height: 24px;
  width: 24px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.icon-3 {
  background-image: url("http://data.xiyilab.com/web/main/static/首页/按钮紫色.png");
}
.message-ding {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5vw;
  height: 1.5vw;
  margin: auto;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  position: relative;
}
.red-point {
  position: absolute;
  width: 0.7vw;
  height: 0.7vw;
  min-width: 14px;
  min-height: 14px;
  background-color: red;
  border-radius: 50%;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.banner-icon:hover .right-icon{
  animation: right 1s ;animation-fill-mode: forwards;
  -webkit-animation: right 1s ;
  -webkit-animation-fill-mode: forwards;

}
@-webkit-keyframes right {
  0%{
    right:2.5vw;
  }
  100%{
    right:1.5vw;
  }
}
@keyframes right {
  0%{
    right:2.5vw;
  }
  100%{
    right:1.5vw;
  }
}
</style>
